import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3af4c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-filter" }

import { onMounted, ref, watch } from 'vue'
import BaseSelect from '@/components/BaseSelect.vue'
import { Option } from '@/models/shared.model'
import { useRoutePlanningServicesMutation } from '@/queries/public/services'
import { debounce } from 'lodash'
import { useFilterStore } from '@/store/filter'
import { useGetAllMaps } from '@/queries/dmoMapQueries'
import { DmoMap } from '@/models/dmoMap.modal'
import { ROUTE_PLANNER_FILTERS } from '@/enums/services'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapFilter',
  emits: ['onChange'],
  setup(__props, { emit: emits }) {

const { query } = useRoute()

const { mutateAsync: fetchServices } = useRoutePlanningServicesMutation()
const { mutateAsync: getAllMaps } = useGetAllMaps()
const debouncedFetchServices = debounce(handleFetchServices, 400)
const { routeServiceFilter, updateRouteServiceFilters } = useFilterStore()

const mapOptions = ref<Option[]>([])
const selectedMap = ref<Option | null>(null)

const removeOption = () => {
  selectedMap.value = null
}

async function handleFetchServices() {
  try {
    const searchResults = await fetchServices(routeServiceFilter.filters)
    emits('onChange', searchResults)
  } catch (e) {
    console.error(e)
  }
}

onMounted(async () => {
  const data = await getAllMaps()
  mapOptions.value = data.map((dmoMap: DmoMap) => ({
    key: dmoMap.id,
    label: dmoMap.name,
  }))
  if (query.mapId) {
    selectedMap.value = mapOptions.value.find(
      ({ key }: Option) => key === Number(query.mapId),
    )
  }
})

watch(
  () => selectedMap.value,
  () => {
    updateRouteServiceFilters(
      selectedMap.value?.key ? String(selectedMap.value?.key) : '',
      ROUTE_PLANNER_FILTERS.MAP,
    )
    debouncedFetchServices()
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseSelect, {
      modelValue: selectedMap.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMap).value = $event)),
      label: _ctx.$t('dmoMap'),
      options: mapOptions.value,
      "return-object": "",
      "close-on-select": "",
      onRemove: removeOption
    }, null, 8, ["modelValue", "label", "options"])
  ]))
}
}

})